<template>
  <kt-datatable v-if="user" v-bind="datatableProps"></kt-datatable>
</template>

<script>
  import columns from './../../settlement/datatable/columns'
  import { ApiUrl } from '@/common/api.service'
  import { AuthorizationHeader } from '@/common/jwt.service'
  import actionsColumn from './../../settlement/datatable/actions'
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('user', ['user']),
      datatableProps() {
        return {
          withPanel: false,
          id: "settlement_datatable",
          data: {
            type: 'remote',
            source: {
              read: {
                url: ApiUrl.path('settlement'),
                method: 'GET',
                headers: AuthorizationHeader,
                map: function(res) {
                  return res.data.data
                },
                params: {
                  user_id: this.user.id
                },
              },
            },
            pageSize: 10,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
          },
          layout: {
          },
          pagination: false,
          sortable: true,
          columns: columns,
          actions: actionsColumn
        }
      },
    }
  }
</script>

<style>

</style>